DislikeReasonsModalController.$inject = ["$scope", "modalData", "onSave"];

function DislikeReasonsModalController($scope, modalData, onSave) {
    const self = this;

    const init = async () => {
        self.modalData = modalData;
    };

    self.close = () => {
        $scope.$hide();
    };

    self.submit = () => {
        onSave({
            userSelected: self.userSelected ?? '',
            additionalReason: self.additionalReason ?? ''
        });
        $scope.$hide();
    };

    init();
}

export const getDislikeReasonsModalController = (modalData, onSave) => {
    return {
        controller: DislikeReasonsModalController,
        controllerAs: '$ctrl',
        templateUrl: '../modules/speedy_screen/components/profile-matching-modals/dislike-reasons-modal/dislike-reasons.modal.html',
        show: true,
        backdrop: false,
        resolve: {
            modalData: modalData,
            onSave: () => onSave
        }
    };
};